import {
  call,
  put,
  takeEvery,
  CallEffect,
  PutEffect,
} from 'redux-saga/effects';
import {
  BenchmarksFailureAction,
  BenchmarksRequestAction,
  BenchmarksSuccessAction,
  MetricRequestAction,
} from 'reducers/benchmarks';
import { Api, APIResult } from 'utils/Api';
import dayjs from 'dayjs';

export function* fetchBenchmarks({
  organizationUUID,
}: BenchmarksRequestAction): Generator<CallEffect | PutEffect> {
  const response: APIResult = yield call(
    Api.get,
    `organizations/${organizationUUID}/benchmark-report`
  );
  if (!response.success) {
    const action: BenchmarksFailureAction = {
      type: 'BENCHMARKS_FAILURE',
      organizationUUID,
      error: response.data?.error_message || 'unknown error',
    };
    yield put(action);
    return;
  }

  const action: BenchmarksSuccessAction = {
    type: 'BENCHMARKS_SUCCESS',
    organizationUUID,
    results: response.data,
  };
  yield put(action);
}

export function* fetchMetric(
  action: MetricRequestAction
): Generator<CallEffect | PutEffect> {
  const {
    organizationUUID,
    byReviewer,
    metric,
    period,
    userName,
    repositoryUUID,
  } = action;
  let url = `organizations/${organizationUUID}/benchmark-metrics?metric=${metric}&days=${period}&timezone=${encodeURI(
    dayjs().format('Z')
  )}`;
  if (byReviewer) {
    url += '&by_reviewer=1';
  }
  if (userName) {
    url += `&user=${userName}`;
  }
  if (repositoryUUID) {
    url += `&repository=${repositoryUUID}`;
  }

  const response: APIResult = yield call(Api.get, url);
  if (!response.success) {
    yield put({
      ...action,
      type: 'BENCHMARK_METRIC_FAILURE',
      error: response.data?.error_message || 'unknown error',
    });
    return;
  }

  yield put({
    ...action,
    type: 'BENCHMARK_METRIC_SUCCESS',
    results: response.data,
  });
}

export const sagas = [
  takeEvery('BENCHMARKS_REQUEST', fetchBenchmarks),
  takeEvery('BENCHMARK_METRIC_REQUEST', fetchMetric),
];
